import React, { useState, useEffect } from 'react';
import './App.css';
import SplashScreen from './components/SplashScreen';
import Login from './components/Login';
import Dashboard from './components/Dashboard';
import EmployeeDirectory from './components/EmployeeDirectory';
import TimeTracking from './components/TimeTracking';
import Chatbot from './components/Chatbot';
import SiteRedirect from './components/SiteRedirect';
import WorkSchedule from './components/WorkSchedule';
import { GoogleOAuthProvider } from '@react-oauth/google';

function App() {
  const [currentUser, setCurrentUser] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [showSplash, setShowSplash] = useState(true);
  const [currentView, setCurrentView] = useState('dashboard'); // 'dashboard' or 'employees'

  useEffect(() => {
    // Check if user is already logged in (from localStorage)
    const savedUser = localStorage.getItem('zenio_user');
    if (savedUser) {
      const user = JSON.parse(savedUser);
      // Migrate old users to have role property
      if (!user.role) {
        if (user.isAdmin) {
          user.role = 'Admin';
        } else if (user.username === 'manager') {
          user.role = 'Manager';
        } else {
          user.role = 'User';
        }
        localStorage.setItem('zenio_user', JSON.stringify(user));
      }
      setCurrentUser(user);
      setShowSplash(false); // Skip splash if already logged in
    }
    setIsLoading(false);
  }, []);

  const handleSplashComplete = () => {
    setShowSplash(false);
  };

  const handleLogin = (user) => {
    setCurrentUser(user);
    localStorage.setItem('zenio_user', JSON.stringify(user));
  };

  const handleLogout = () => {
    setCurrentUser(null);
    localStorage.removeItem('zenio_user');
  };

  if (showSplash) {
    return <SplashScreen onComplete={handleSplashComplete} />;
  }

  if (isLoading) {
    return <div className="loading">Loading...</div>;
  }

  // Check if URL path is /employeedirectory
  const isEmployeeDirectory = window.location.pathname === '/employeedirectory';
  
  // Check if URL path is /timetracking
  const isTimeTracking = window.location.pathname === '/timetracking';
  
  // Check if URL path is /chatbot
  const isChatbot = window.location.pathname === '/chatbot';
  
  // Check if URL path is /siteredirect
  const isSiteRedirect = window.location.pathname === '/siteredirect';
  
  // Check if URL path is /workschedule
  const isWorkSchedule = window.location.pathname === '/workschedule';

  // Show Site Redirect page (no login required)
  if (isSiteRedirect) {
    return (
      <div className="App">
        <SiteRedirect />
      </div>
    );
  }

  // Show Employee Directory without requiring login
  if (isEmployeeDirectory) {
    return (
      <div className="App">
        <EmployeeDirectory 
          user={currentUser || { name: 'Guest', isAdmin: false }}
          onBack={() => window.location.href = '/'}
        />
      </div>
    );
  }

  // Show Time Tracking - REQUIRES LOGIN
  if (isTimeTracking) {
    if (!currentUser) {
      // Not logged in, show login page
      return (
        <div className="App">
          <Login onLogin={handleLogin} />
        </div>
      );
    }
    // Logged in, show time tracking
    return (
      <div className="App">
        <TimeTracking 
          user={currentUser}
          onBack={() => window.location.href = '/'}
        />
      </div>
    );
  }

  // Show Chatbot - REQUIRES LOGIN
  if (isChatbot) {
    if (!currentUser) {
      // Not logged in, show login page
      return (
        <div className="App">
          <Login onLogin={handleLogin} />
        </div>
      );
    }
    // Logged in, show chatbot
    return (
      <div className="App">
        <Chatbot 
          user={currentUser}
          onBack={() => window.location.href = '/'}
        />
      </div>
    );
  }

  // Show Work Schedule - REQUIRES LOGIN
  if (isWorkSchedule) {
    if (!currentUser) {
      // Not logged in, show login page
      return (
        <div className="App">
          <Login onLogin={handleLogin} />
        </div>
      );
    }
    // Logged in, show work schedule
    return (
      <div className="App">
        <WorkSchedule 
          user={currentUser}
          onBack={() => window.location.href = '/'}
        />
      </div>
    );
  }

  return (
    <GoogleOAuthProvider clientId="419102591900-3659smpmjlrhinbi0q17rk4j38obr3ms.apps.googleusercontent.com">
      <div className="App">
        {!currentUser ? (
          <Login onLogin={handleLogin} />
        ) : (
          <Dashboard 
            user={currentUser} 
            onLogout={handleLogout}
          />
        )}
      </div>
    </GoogleOAuthProvider>
  );
}

export default App;
